import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-iframe-loader',
    templateUrl: './iframe-loader.component.html',
    styleUrls: ['./iframe-loader.component.scss'],
    standalone: false
})
export class IframeLoaderComponent implements OnInit {

  ngOnInit(): void {
    console.log('🔵 [IFRAME-LOADER] Componente inicializado');
    
    // Envía un mensaje al parent cuando se carga el componente
    if (window.parent !== window) {
      console.log('📡 [IFRAME-LOADER] Detectado iframe - enviando mensaje al parent');
      window.parent.postMessage({ 
        status: 'loaded', 
        url: window.location.href,
      }, '*');
      console.log('✅ [IFRAME-LOADER] Mensaje enviado al parent');
    } else {
      console.log('⚠️ [IFRAME-LOADER] No se detectó iframe - componente cargado en ventana principal');
    }
  }
}
